import home from './src/home.vue'  //监控设备管理
import monitorInfo from './src/monitorInfo.vue' //监控设备管理详情

import realTimeVideo from './src/realTimeVideo/realTimeVideo.vue' //实时视频
import realTimeVideoYingyan from './src/realTimeVideo/realTimeVideoYingyan.vue' // 鹰眼视频
import PlaybackVideo from './src/playBackVideo/PlaybackVideo.vue' //回放视频视频
import swiperVideo from './src/swiperVideo/swiperVideo.vue' //视频轮播
import swiperVideoList from './src/swiperVideo/swiperVideoList.vue' //视频轮播列表

import PassengerflowView from './src/Passengerflow/PassengerflowView.vue'  //客流监测集成
import MonitorPermissionManage from './src/MonitorPermission/MonitorPermissionManage.vue' //监控权限管理
import MonitorDeviceList from './src/MonitorPermission/MonitorDeviceList.vue' //监控权限管理

let views = {
    home,
    monitorInfo,
    realTimeVideo,
    realTimeVideoYingyan,
    PlaybackVideo,
    swiperVideo,
    swiperVideoList,
    PassengerflowView,
    MonitorPermissionManage,
    MonitorDeviceList
};

export default views;